"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCountryCode = setCountryCode;
exports.setIsPublic = setIsPublic;
exports.default = meta;
exports.initialState = exports.SET_IS_PUBLIC = exports.SET_COUNTRY_CODE = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SET_COUNTRY_CODE = 'SET_COUNTRY_CODE';
exports.SET_COUNTRY_CODE = SET_COUNTRY_CODE;
var SET_IS_PUBLIC = 'SET_IS_PUBLIC';
exports.SET_IS_PUBLIC = SET_IS_PUBLIC;

function setCountryCode(code) {
  if (typeof code !== 'string') throw new Error("code is required and must be a string -- received: ".concat(code));
  return {
    type: SET_COUNTRY_CODE,
    code: code
  };
}

function setIsPublic(value) {
  if (typeof value !== 'boolean') throw new Error("value is required and must be a boolean -- received: ".concat(value));
  return {
    type: SET_IS_PUBLIC,
    value: value
  };
}

var initialState = {
  country: 'US'
};
exports.initialState = initialState;

function meta() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_COUNTRY_CODE:
      return _objectSpread({}, state, {
        country: action.code
      });

    case SET_IS_PUBLIC:
      return _objectSpread({}, state, {
        isPublic: action.value
      });

    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./lib/utils/utilsModule.js
// module id = 38
// module chunks = 0